import { render, staticRenderFns } from "./AddEditBatchEndpointChildModal.vue?vue&type=template&id=19e20e0a&scoped=true"
import script from "./AddEditBatchEndpointChildModal.vue?vue&type=script&lang=js"
export * from "./AddEditBatchEndpointChildModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e20e0a",
  null
  
)

export default component.exports